import axios from "axios";
import { requestWrapper } from "./serviceFactory";

const axiosPublicInstance = axios.create({
  baseURL: `${process.env.REACT_APP_REQUEST_PUBLIC}`,
});

export async function getAllInstitutions(germanIsraeliOnly = false) {
  return await requestWrapper(
    axiosPublicInstance.get(`/utility/institutions`, {
      params: { all: !germanIsraeliOnly },
    })
  );
}
export async function getAllCountries() {
  return await requestWrapper(axiosPublicInstance.get(`/utility/countries`));
}
export async function GetContactTitles() {
  return await requestWrapper(
    axiosPublicInstance.get(`/utility/options/contacttitles`)
  );
}
export async function GetBudgetCodes() {
  return await requestWrapper(
    axiosPublicInstance.get(`/utility/options/budgetcodes`)
  );
}
